module.exports = window.__clic_libs["chosen-js"];